import { render, staticRenderFns } from "./backorderCustList.vue?vue&type=template&id=cb63b51a&"
import script from "./backorderCustList.vue?vue&type=script&lang=js&"
export * from "./backorderCustList.vue?vue&type=script&lang=js&"
import style0 from "./backorderCustList.vue?vue&type=style&index=0&id=cb63b51a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports